import { render, staticRenderFns } from "./designView.vue?vue&type=template&id=8560d74e&"
import script from "./designView.vue?vue&type=script&lang=ts&"
export * from "./designView.vue?vue&type=script&lang=ts&"
import style0 from "./designView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports